import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=dab1c256&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=dab1c256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab1c256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dab1c256')) {
      api.createRecord('dab1c256', component.options)
    } else {
      api.reload('dab1c256', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=dab1c256&scoped=true&", function () {
      api.rerender('dab1c256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MNuX5tdLd1tY/JS/comp/PopupBox.vue"
export default component.exports